













import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

@Component
export default class notifications extends Vue {
  @Getter public isError: boolean;
  @Getter public isSuccess: boolean;
  @Getter public successMessage: string;
  @Getter public errorMessage: string;
}
